import { writeLocalStorage } from "./action";
import {
  ISUSER_FALSE,
  ISUSER_TRUE,
  LOGIN_ERROR,
  LOGIN_LOADING,
  LOGIN_SUCCESS,
  SIGNUP_LOADING,
  SINGUP_ERROR,
  SINGUP_SUCCESS,
} from "./actionType";

let init = JSON.parse(localStorage.getItem("user")) || {
  email: "",
  name: "",
  role: "",
  token: "",
  isAuth: false,
  isError: "",
  loading: false,
  success: false,
  isUser: false,
  userId: "",
  place: "",
  age: "",
  message: "",
  user: null,
  companyId: "",
  companyName: "",
  hasCompletedLna: false
};

const reducer = (state = init, action) => {
  const { type, payload } = action;
  var newState;
  switch (type) {
    case LOGIN_LOADING:
      newState = {
        ...state,
        isAuth: false,
        token: "",
        isError: "",
        loading: true,
      };
      writeLocalStorage("user", newState);
      return newState;

    case LOGIN_SUCCESS:
      sessionStorage.setItem("isSsoSession", "true");
      newState = {
        ...state,
        loading: false,
        isAuth: true,
        token: payload.token,
        name: payload.user.fullName || payload.user.name,
        role: payload.user.role,
        email: payload.user.email,
        sector: payload.user.sector || "",
        department: payload.user.department || "",
        userId: payload.user.id || payload.user._id,
        place: payload.user.city || "",
        age: payload.user.age || "",
        job: payload.user.job || "",
        message: payload?.msg || "Login Successful",
        isError: "",
        user: payload.user,
        companyId: payload.user.companyId || "",
        companyName: payload.user.companyName || "",
        hasCompletedLna: payload.user.hasCompletedLna !== undefined ? payload.user.hasCompletedLna : false
      };
      writeLocalStorage("user", newState);
      return newState;

    case LOGIN_ERROR:
      newState =  {
        ...state,
        loading: false,
        isAuth: false,
        isError: payload,
        token: "",
      };
      writeLocalStorage("user", newState);
      return newState;

    case SIGNUP_LOADING:
      newState =  { ...state, isAuth: false, token: "", isError: "", loading: true };
      writeLocalStorage("user", newState);
      return newState;

    case SINGUP_SUCCESS:
      newState =  { ...state, loading: false, success: true };
      writeLocalStorage("user", newState);
      return newState;

    case SINGUP_ERROR:
      newState =  { ...state, loading: false, isError: payload };
      writeLocalStorage("user", newState);
      return newState;

    case ISUSER_TRUE:
      newState =  { ...state, isUser: true };
      writeLocalStorage("user", newState);
      return newState;
    case ISUSER_FALSE:
      newState =  { ...state, isUser: false };
      writeLocalStorage("user", newState);
      return newState;

    case "USER_LOGOUT":
      localStorage.removeItem("user");
      sessionStorage.clear();
      return {
        ...state,
        loading: false,
        isAuth: false,
        token: "",
        name: "",
        role: "",
        email: "",
        userId: "",
        message:'',
        age:"",
        job:"",
        place:"",
        user: null,
        companyId: "",
        companyName: "",
        hasCompletedLna: false
      };

    default:
      newState =  { ...state };
      writeLocalStorage("user", newState);
      return newState;
  }
};

export { reducer };
